import type { ServerEvent } from "@spacecrew/shared";
import type { ShipState } from "@spacecrew/shared/schema";
import type { ToJSON } from "@colyseus/schema";

export type Snap = ToJSON<ShipState>;

/**
 * The synced world as plain JSON snapshots. One `$state.raw` assignment per server patch (10 Hz);
 * every snapshot is a fresh object, so `$derived` reads are always correct — no per-field callbacks.
 */
class ShipStore {
  snap = $state.raw<Snap | null>(null);
  /** Last ~20 server events (audio hook + corporate copy), newest last. */
  events = $state<ServerEvent[]>([]);
  lastHook = $state("");

  pushEvent(e: ServerEvent) {
    this.lastHook = e.hook;
    this.events = [...this.events.slice(-19), e];
  }
  reset() {
    this.snap = null;
    this.events = [];
    this.lastHook = "";
  }
}

export const ship = new ShipStore();
